import React from 'react'
import DirectionsIcon from 'react-icons/lib/md/directions'
import Loading from '@components/SuspenseLoading/Loading'
import {getPlaceDetails_cached_place} from '@data/queries/components/__generated__/getPlaceDetails_cached'
import {placeDetailQuery} from '@data/queries/components/placeDetail'
import isMobile from '@helpers/misc/isMobile'
import isServerSide from '@helpers/misc/isServerSide'
import {useApolloQuery} from '@packages/apollo-hooks'
import Tooltip from '@packages/justo-parts/lib/components/Tooltip'

import styles from './styles.module.css'

export default function Address({
  placeId,
  ssrAddress
}: {
  placeId: string
  ssrAddress?: getPlaceDetails_cached_place
}) {
  const {place: queriedPlace} = useApolloQuery({
    query: placeDetailQuery,
    variables: {placeId},
    partial: true,
    omit: isServerSide()
  })
  const place = queriedPlace ? queriedPlace : ssrAddress
  if (isServerSide() && !ssrAddress) {
    console.warn(
      'Could not fetch place while doing SSR. This should be fixed for an optimized experience'
    )
    return <Loading />
  }

  const onClick = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${placeId}`
    if (isMobile) {
      window.location.href = url
    } else {
      window.open(url)
    }
  }
  return (
    <div className={styles.container} onClick={onClick}>
      <Tooltip content="Abrir en Google Maps">
        <DirectionsIcon style={{marginRight: 8, top: -1, position: 'relative'}} />
        {place ? place.text : 'Cargando...'}
      </Tooltip>
    </div>
  )
}
